import { render, staticRenderFns } from "./OrderHeader.vue?vue&type=template&id=0d276fb2"
import script from "./OrderHeader.vue?vue&type=script&lang=js"
export * from "./OrderHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports